import { FC, PropsWithChildren, ButtonHTMLAttributes } from 'react'
import cn from 'classnames'

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'contained' | 'default' | 'black' | 'blue' | 'gray' | 'square' | 'outlined'
  label?: string
}

const buttonVariants = {
  contained: 'text-white bg-base-medium-light rounded-lg py-6 px-8 darken leading-none',
  default: 'darken rounded-lg',
  black: 'bg-black py-4 px-8 text-white rounded-lg border',
  blue: 'base-medium-light',
  gray: 'font-bold text-white bg-base-medium-light p-4 border-none rounded-2xl hover:bg-base-medium-light transition-colors',
  square:
    'bg-base-medium-light darken flex size-9 items-center justify-center rounded-lg border-none leading-none text-white',
  outlined: 'border-neutral-medium-light h-20 w-1/2 items-center justify-between rounded-2xl border flex px-4 md:w-64',
}

export const Button: FC<PropsWithChildren<ButtonProps>> = ({
  children,
  variant = 'default',
  className,
  label,
  ...props
}) => {
  return (
    <button
      className={cn(
        'disabled:bg-neutral-medium-lighter block not-disabled:cursor-pointer disabled:cursor-default',
        buttonVariants[variant],
        className
      )}
      {...props}
    >
      {label && <span className="flex items-baseline">{label}</span>}
      {children}
    </button>
  )
}
